/**
 *
 * ConfirmModal
 *
 */

import * as PropTypes from "prop-types";
import styled from "styled-components";
import ActionButton from "basicComponents/ActionButton/ActionButton";
import GlobalMessages from "messages/messages";
import {FormattedMessage} from "react-intl";
import Modal from "basicComponents/Modal/Modal";

function noBubble(e) {
  e.stopPropagation();
}

function ConfirmModal({ open, onConfirm, onCancel, children, disabled, showCancel = true }) {
  return (
    <Modal open={open} onClose={onCancel}>
      <Content onClick={noBubble}>
        <div data-cy="confirmModal">{children}</div>
        {!disabled && (
          <ButtonRow>
            <ActionButton id="confirmButton" autofocus onClick={onConfirm}>
              <FormattedMessage {...GlobalMessages.confirm} />
            </ActionButton>
            {showCancel && (<ActionButton id="cancelButton" onClick={onCancel}>
              <FormattedMessage {...GlobalMessages.cancel} />
            </ActionButton>)}
          </ButtonRow>
        )}
      </Content>
    </Modal>
  );
}

ConfirmModal.propTypes = {
  children: PropTypes.any,
  open: PropTypes.bool,
  onConfirm: PropTypes.func,
  onCancel: PropTypes.func,
  disabled: PropTypes.bool,
};

function noop() {}
ConfirmModal.defaultProps = {
  onConfirm: noop,
  onCancel: noop,
};

export default ConfirmModal;

const ButtonRow = styled.div`
  display: flex;
  justify-content: center;
  margin-top: ${({ theme }) => theme.margin}rem;

  button:first-child {
    margin-right: ${({ theme }) => theme.margin}rem;
  }
`;

const Content = styled.div`
  padding: ${({ theme }) => theme.padding}rem;
  border-radius: ${({ theme }) => theme.borderRadius};

  background-color: white;
`;
